import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";

const CarBusinessHistory = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"자동차판매사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <div className="kor">자동차사업</div>
              <div className="eng">Car Business</div>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"320px"}>
            <S.NavItem>
              <Link to="/CarBusiness/CarBusinessHistory">
                <div className="kor">자동차사업이력</div>
                <div className="eng">Major business history</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/introduce">
                              <div className="kor">자동차사업</div>
                              <div className="eng">Car Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/Sales">
                              <div className="kor">자동차 판매사업</div>
                              <div className="eng">Automotive Sales Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsService">
                              <div className="kor">AS정비사업</div>
                              <div className="eng">AS maintenance business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/RentalService">
                              <div className="kor">렌터카 사업</div>
                              <div className="eng">Vehicle Rental Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsParts">
                              <div className="kor">A/S 부품 사업</div>
                              <div className="eng">After-Sales (A/S) Parts Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/CarBusinessHistory">
                              <div className="kor">자동차사업이력</div>
                              <div className="eng">Major business history</div>
                            </Link>
                          </S.NavItem>
                        </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"자동차사업 / 주요사업이력"} titleeng={"Zyle Motors Overseas Business / Major business history"} />
            <S.HistoryTable class="history-table">
              <div class="history-table-head">
                <div class="history-table-ceil-small"  style={{ borderRightColor: "#fff" }}>
                  <div className="kor">구분</div>
                  <div className="eng">Year</div>
                </div>
                <div class="history-table-ceil-big">
                  <div className="kor">주요 사업내용</div>
                  <div className="eng">Major business history</div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1993</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">대우자동차(주)로부터 영업부문 분리, 대우자동차판매(주) 설립</div>
                    <div className="eng">
                      Separation of Business division from Daewoo Motor Co. , 
                      <br />
                      Daewoo Motor Co., Ltd. Sales establish
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1994</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">대우자동차판매㈜에서 우리자동차판매(주) 사명 변경</div>
                    <div className="eng">Daewoo Motor Co., Ltd.Sales Co., Ltd. changed its name to Woori Motor Sales</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1996</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)한독과 합병</div>
                    <div className="eng">Merged with Handok.Inc.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1997</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">대우계열 소속사로 편입, 우리자동차판매(주)에서(주)대우자판으로 사명 변경</div>
                    <div className="eng">
                      Transferred to Daewoo affiliated company, 
                      <br />
                      changed its name from Woori Motor Sales Inc.to Daewoo Motor Sales Co.Ltd
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1999</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)대우자판에서 대우자동차판매(주)로 사명 변경</div>
                    <div className="eng">9 Changed the name of Daewoo Motor Co., Ltd.Sales from Daewoo Motor Sales Inc</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2000</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">대우계열에서 분리, 전국 12개 정비법인 계열사로 편입</div>
                    <div className="eng">
                      Separation from 'Daewoo' system, 
                      <br />
                      transferred to 12 Repair Corporation subsidiaries nationwide
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2010</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">기업개선작업(워크아웃)</div>
                    <div className="eng">Business improvement (workout)</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2011</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">회생계획안 인가 결정, 대우자동차판매(주) 법인 신설</div>
                    <div className="eng">Authorization decision for rehabilitation plan,
                      <br />
                      Sales Corporation newly open from Daewoo Motor Co., Ltd.
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2012</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">영안계열사로 편입 / 대우자동차판매(주)에서 자일자동차판매(주)로 사명 변경</div>
                    <div className="eng">
                      Transfer to Young an affiliates 
                      <br />
                      / Changed the name of 'Daewoo Motor Co., Ltd.Sales' to ZYLE Motor Sales
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2015</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">자일자동차판매(주)에서 자일대우자동판매(주)로 사명 변경</div>
                    <div className="eng">ZYLE Motor Sales Inc. changed its name to ZYLE Daewoo Motor Sales Co.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2018</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">자일대우자동차판매(주)에서 자일자동차판매(주)로 사명변경</div>
                    <div className="eng">Change of name from Zyle Daewoo Motor Sales Co., Ltd. to Zyle Motor Sales Co., Ltd.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2021</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">자일자동차판매(주)에서 자일자동차(주)로 사명 변경</div>
                    <div className="eng">Change of name from Zyle Motors Sales Co., Ltd. to Zyle Motors Co., Ltd.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2024</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">국내 버스 판매사업 중단</div>
                    <div className="eng">Discontinued domestic bus sales business</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2025</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">르노코리아 승용차 판매사업 개시</div>
                    <div className="eng">Launched Renault Korea passenger car sales business</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line last-line">
                <div class="history-table-ceil-small">2026</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">캐딜락 & GMC 승용차 판매사업 개시
</div>
                    <div className="eng">Launched Cadillac & GMC passenger car sales business</div>
                  </div>
                </div>
              </div>
            </S.HistoryTable>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default CarBusinessHistory;
